import React from 'react';
import Logo from '../../Images/Logo/Logo.png';
import './BrandLoader.css';

const BrandLoader = ({ message = 'Loading...', overlay = false }) => (
    <div className={`brand-loader${overlay ? ' brand-loader-overlay' : ''}`} role="status" aria-live="polite">
        <img src={Logo} alt="1FIVE" />
        <span className="brand-loader-spinner" aria-hidden="true" />
        <p>{message}</p>
    </div>
);

export default BrandLoader;
